<template>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">Laboratory Claims</div>
      <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :loading="loading" :headers="setHeadersByRole" :items="patient_data" :search="search">
      <template v-slot:no-data> No Claims </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Laboratory',
  props: ['patient', 'insurance', 'recordLimit'],

  data() {
    return {
      search: '',
      user:'',
      extra:[],
      loading: false,
      headers: [
          {
            text: 'Claim ID',
            sortable: false,
            value: 'CLAIM_ID',
          },
          { text: 'Claim Date', value: 'CLAIM_DATE' },
          { text: 'Result Name', value: 'RESULT_NAME' },
          { text: 'Result Units', value: 'RESULT_UNITS' },
          { text: 'Result Value Literal', value: 'RESULT_VALUE_LITERAL' },
          { text: 'Normal High Value', value: 'NORMAL_HIGH_VALUE' },
          { text: 'Normal Low Value', value: 'NORMAL_LOW_VALUE' },
          { text: 'LOINC', value: 'LOINC' },
          { text: 'Physician Name/NPI', value: 'PHYSICIAN_NAME' },
        ],
      patient_data: [],
    };
  },
  mounted() {
    this.getClaims();
    this.getUser();
  },
  methods: {
    async getUser() {
      await axios
        .get('/api/user')
        .then((response) => {
          console.log(response, "response")
          this.user = response.data[0];
        })
        .catch((err) => this.$router.push('/login'));
    },
    async getClaims() {
      this.loading = true;
      // this.getHeaders();
      await axios
        .get(`/api/patient/claims/laboratory/${this.insurance}/${this.patient}/${this.recordLimit}`)
        .then((response) => {
          this.patient_data = response.data;
          this.loading = false;
        });
    },
    // async getHeaders() {
    //   const insurance = this.insurance.toLowerCase();

    //   if (insurance === 'careplus') {
    //     this.headers = [
    //       {
    //         text: 'Claim ID',
    //         sortable: false,
    //         value: 'LAB_CLAIM_ID',
    //       },
    //       { text: 'Claim Date', value: 'CLAIM_DATE' },
    //       { text: 'Facility', value: 'FACILITY' },
    //       { text: 'Diagnosis Code', value: 'PRIMARY_DIAG' },
    //       { text: 'Diagnosis Description', value: 'DIAG_DESC' },
    //       { text: 'Procedure Code', value: 'PROC_ID' },
    //       { text: 'Procedure Description', value: 'PROC_DESC' },
    //       { text: 'Amount', value: 'AMOUNT' },
    //     ];
    //   } else {
    //     this.headers = [
    //       {
    //         text: 'Claim ID',
    //         sortable: false,
    //         value: 'CLAIM_ID',
    //       },
    //       { text: 'Claim Date', value: 'CLAIM_DATE' },
    //       { text: 'Result Name', value: 'RESULT_NAME' },
    //       { text: 'Result Units', value: 'RESULT_UNITS' },
    //       { text: 'Result Value Literal', value: 'RESULT_VALUE_LITERAL' },
    //       { text: 'Normal High Value', value: 'NORMAL_HIGH_VALUE' },
    //       { text: 'Normal Low Value', value: 'NORMAL_LOW_VALUE' },
    //       { text: 'LOINC', value: 'LOINC' },
    //       { text: 'Physician Name/NPI', value: 'PHYSICIAN_NAME' },
    //     ];
    //   }
    // },
  },
  computed: {
    setHeadersByRole(){
      if(this.user.role === "Member"){
        this.extra = ["LOINC"]
      }

      this.headers = this.headers.filter((field) => {
        return this.extra.includes(field.value) === false
      })

      return this.headers
    },
  },
};
</script>
